
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import { getJobBySlug } from "@utils/get-jobs";
import parse from "html-react-parser";
import Image from "next/image";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
interface IJob {
    job: {
        title: string;
        content: string;
        jobOfferDetails: {
            location: string;
            niceToSee: string;
            responsibilities: string;
            weOffer: string;
            weWait: string;
        };
        featuredImage: {
            node: {
                sourceUrl: string;
                mediaDetails: {
                    width: number;
                    height: number;
                };
            };
        };
    };
}
const CareerItem: NextPage<IJob> = ({ job }) => {
    // console.log('job', job);
    return (<>
      <NextSeo openGraph={{
            images: [
                {
                    alt: job?.title,
                    height: job?.featuredImage?.node?.mediaDetails?.height,
                    url: job?.featuredImage?.node?.sourceUrl,
                    width: job?.featuredImage?.node?.mediaDetails?.width,
                },
            ],
            // url: 'https://www.example.com/page',
            title: `${job?.title} - KNS Okna`,
            type: "website",
        }} title={`${job?.title} - KNS Okna`}/>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
        {/* <Breadcrumb product={product?.title} /> */}
        <Image alt={job?.title} height={job?.featuredImage?.node?.mediaDetails?.height} src={job?.featuredImage?.node?.sourceUrl} width={job?.featuredImage?.node?.mediaDetails?.width}/>
        <h1 className="mb-2 p-1 font-bold text-4xl">{job?.title}</h1>
        <div>
          {job?.jobOfferDetails?.location
            ? job?.jobOfferDetails?.location
            : null}
        </div>
        <div className="py-4">{parse(job?.content || "")}</div>
      </div>
      {job?.jobOfferDetails.responsibilities ? (<div className="bg-gray">
          <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
            <span className="mr-1 text-orange">■</span>
            <strong>ZAKRES OBOWIĄZKÓW:</strong>
            <br />
            <div className="ml-3">
              {parse(job?.jobOfferDetails.responsibilities || "")}
            </div>
            <br />
          </div>
        </div>) : null}
      {job?.jobOfferDetails.weWait ? (<div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <span className="mr-1 text-orange">■</span>
          <strong>OCZEKUJEMY:</strong>
          <br />
          <div className="ml-3">{parse(job?.jobOfferDetails.weWait || "")}</div>
          <br />
        </div>) : null}
      {job?.jobOfferDetails.weOffer ? (<div className="bg-gray">
          <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
            <span className="mr-1 text-orange">■</span>
            <strong>OFERUJEMY:</strong>
            <br />
            <div className="ml-3">
              {parse(job?.jobOfferDetails.weOffer || "")}
            </div>
            <br />
          </div>
        </div>) : null}
      {job?.jobOfferDetails.niceToSee ? (<div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <span className="mr-1 text-orange">■</span>
          <strong>MILE WIDZIANE:</strong>
          <br />
          <div className="ml-3">
            {parse(job?.jobOfferDetails.niceToSee || "")}
          </div>
          <br />
        </div>) : null}
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <span className="mr-1 text-orange">■</span>
        <strong>ZAINTERESOWANY?</strong>
        <br />
        Wyślij maila na adres:{" "}
        <a href="mailto:rekrutacja@kns-okna.pl">rekrutacja@kns-okna.pl</a>
        <br />
        Rekrutacja: +48 514 602 062
        <br />
        <br />
      </div>
      <div className="w-full bg-black pb-6 text-white">
        <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
          <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
            PROCES REKRUTACJI
          </h1>
          <div className="flex flex-wrap justify-around py-1 text-lg">
            <div className="m-1 w-64 min-w-[150px] max-w-[200px]">
              <div className="flex w-fit">
                <Image alt="cv" className="h-32 w-1/2" height={192} src="/img/career/1.png" width={118}/>
                <Image alt="cv" className="w-1/2" height={172} src="/img/career/cv.png" width={172}/>
              </div>
              przegląd aplikacji
            </div>
            <div className="m-1 w-64 min-w-[150px] max-w-[200px]">
              <div className="flex">
                <Image alt="telefon" className="h-32 w-1/2" height={192} src="/img/career/2.png" width={156}/>
                <Image alt="telefon" className="w-1/2" height={172} src="/img/career/telefon.png" width={172}/>
              </div>
              zadzwonimy do Ciebie
              <br />
              <span className="text-sm">(do wybranych osób)</span>
            </div>
            <div className="m-1 w-64 min-w-[150px] max-w-[200px]">
              <div className="flex">
                <Image alt="rozmowa" className="h-32 w-1/2" height={192} src="/img/career/3.png" width={118}/>
                <Image alt="rozmowa" className="w-1/2" height={172} src="/img/career/rozmowa.png" width={172}/>
              </div>
              rozmowa rekrutacyjna
            </div>
            <div className="m-1 w-64 min-w-[150px] max-w-[200px]">
              <div className="flex">
                <Image alt="wspolpraca" className="h-32 w-1/2" height={192} src="/img/career/4.png" width={118}/>
                <Image alt="wsplpraca" className="w-1/2" height={172} src="/img/career/wspolpraca.png" width={172}/>
              </div>
              podjęcie współpracy
              <br />
              <span className="text-sm">(wybór najlepszego kandydata)</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-2 pt-4 text-xs lg:px-0">
        Administratorem Danych Osobowych jest Śląska Fabryka Okien KNS z
        siedzibą w Wodzisławiu.
        <br />
        <br />
        Podanie danych osobowych w CV jest dobrowolne, lecz konieczne do
        przeprowadzenia procesu rekrutacyjnego. Konsekwencją niepodania danych
        osobowych będzie brak możliwości przeprowadzenia postępowania
        rekrutacyjnego. Dane osobowe przetwarzane będą na podstawie art. 6 ust.
        1 pkt. a i c ogólnego rozporządzenia o ochronie danych osobowych z 27
        kwietnia 2016 r. (RODO).
        <br />
        <br />
        Przysługuje Pani/ Panu prawo dostępu do treści swoich danych osobowych
        oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania,
        prawo do przenoszenia danych, prawo do wniesienia sprzeciwu, prawo do
        cofnięcia zgody na ich przetwarzanie w dowolnym momencie bez wpływu na
        zgodność z prawem przetwarzania, którego dokonano na podstawie zgody
        przed jej cofnięciem.
        <br />
        <br />
        Przysługuje Pani/Panu prawo wniesienia skargi na przetwarzanie danych do
        Prezesa Urzędu Ochrony Danych Osobowych. Dane osobowe będą przetwarzane
        do momentu zakończenia prowadzenia rekrutacji, nie dłużej jednak niż
        przez trzy miesiące od dnia przesłania CV.
        <br />
        <br />
        Za zgodą kandydatów w okresie 1 roku od zakończenia procesu
        rekrutacyjnego dane osobowe będą przetwarzane w kolejnych rekrutacjach
        prowadzonych przez administratora danych osobowych.
        <br />
        <br />
        Dane osobowe kandydatów nie będą podlegały zautomatyzowanemu
        przetwarzaniu.
        <br />
        <br />
        Proszę o zawarcie w aplikacji zgody o następującej treści:
        <br />
        <span className="italic">
          Wyrażam zgodę na przetwarzanie danych osobowych zawartych w mojej
          aplikacji przez Śląską Fabrykę Okien KNS Sp. z o.o. z siedzibą w
          Wodzisławiu na potrzeby przeprowadzenia procesu rekrutacji.
        </span>
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = () => {
    const paths: never[] = [];
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const { job } = await getJobBySlug(slug);
    if (!job) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            job,
        },
    };
};
export default CareerItem;

    async function __Next_Translate__getStaticProps__1a19cd2befb__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/career/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2befb__ as getStaticProps }
  